<template>

    <GuideLayout :title="title">

        <div class="flex flex-col xl:flex-row bg-white rounded-lg mt-14 xl:min-w-[1200px]">


            <div class="grid grid-cols-1 sm:grid-cols-2 grid-rows-6 sm:grid-rows-4 p-8 w-full xl:w-2/3">

                <div class="col-span-2 font-nexa text-blue text-3xl leading-normal">{{ __('Your information') }}</div>


                <div class="flex flex-col xl:mr-6 col-span-2 xl:col-span-1 mt-4 xl:mt-0">

                    <label class="font-nexa text-black text-lg" for="name">{{ __('Name') }} *</label>

                    <input class="flex rounded-lg border border-gray-200 p-4 mt-2"
                        type="text"
                        id="name"
                        v-model="form_name" />

                    <div class="text-red font-bold">{{ errors.name }}</div>

                </div>


                <div class="flex flex-col col-span-2 xl:col-span-1 mt-4 xl:mt-0">

                    <label for="email" class="font-nexa text-black text-lg">{{ __('Email') }} *</label>

                    <input class="flex rounded-lg border border-gray-200 p-4 mt-2"
                        type="text"
                        id="email"
                        @input="handle_email_input"
                        v-model="form_email" />

                    <div class="text-red font-bold">{{ errors.email }}</div>

                </div>


                <div class="flex flex-col mt-4 xl:mr-6 col-span-2 xl:col-span-1">

                    <label for="password" class="font-nexa text-black text-lg">{{ __('Password') }} *</label>

                    <input class="flex rounded-lg border border-gray-200 p-4 mt-2"
                        type="password"
                        id="password"
                        v-model="password" />

                    <div class="text-red font-bold">{{ errors.password }}</div>

                </div>


                <div class="flex flex-col mt-4 col-span-2 xl:col-span-1">

                    <label for="password_confirmation" class="font-nexa text-black text-lg">{{ __('Confirm password') }} *</label>

                    <input class="flex rounded-lg border border-gray-200 p-4 mt-2"
                        type="password"
                        id="password_confirmation"
                        v-model="password_confirmation" />

                    <div class="text-red font-bold">{{ errors.password_confirmation }}</div>

                </div>


                <div class="flex flex-col mt-4 font-bold cursor-pointer w-full col-span-2 xl:col-span-1">

                    <div class="flex flex-col xl:flex-row items-start xl:items-center w-full">

                        <font-awesome-icon
                            :icon="['far', 'square']"
                            size="2x"
                            class="flex text-blue mr-4 mb-2 xl:mb-0"
                            :class="{
                                'hidden': terms
                            }"
                            style="width: 27px; height: 27px"
                            @click.stop="terms = ! terms"
                        ></font-awesome-icon>

                        <font-awesome-icon
                            :icon="['fas', 'check-square']"
                            size="2x"
                            class="flex text-blue mr-4 mb-2 xl:mb-0"
                            style="width: 27px; height: 27px;"
                            :class="{
                                'hidden': ! terms
                            }"
                            @click.stop="terms = ! terms"
                        ></font-awesome-icon>

                        <div class="mr-2 xl:whitespace-nowrap select-none mb-2 xl:mb-0"
                             @click.stop="terms = ! terms">{{ __('Accept terms of service') }} *</div>

                        <Link class="underline hover:text-blue cursor-pointer xl:whitespace-nowrap bg-transparent text-black px-0 hoved:bg-transparent hover:text-gray-400"
                            :is_font_sans="true"
                            :href="route('terms.show')">

                            {{ __('Read more') }}

                        </Link>

                    </div>

                    <div class="text-red font-bold">{{ errors.terms }}</div>

                </div>

            </div>


            <div class="flex flex-col justify-center border-t xl:border-l border-gray-200 xl:ml-4 py-8 px-8 xl:pl-14">

                <div class="font-bold font-nexa text-lg mb-4">
                    {{ __('The benefits of doing break fitness exercises') }}
                </div>

                <div class="flex items-center mb-4"
                    v-for="pro of pros">

                    <font-awesome-icon
                        :icon="['fas', 'check']"
                        size="2x"
                        class="text-green mr-3"
                        style="width: 16px; height: 16px">
                    </font-awesome-icon>

                    {{ __( pro ) }}

                </div>

            </div>

        </div>

        <div class="mx-auto flex flex-col justify-start items-center xl:flex-row xl:justify-center xl:items-start">

            <Button
                class="mt-10 bg-blue bg-opacity-0 border border-gray-400 text-2xl text-black pl-12 pr-12 pt-5 pb-4 xl:mr-10 hover:opacity-40 hover:text-white"
                @click="handle_click_previous">
                {{ __('Previous') }}
            </Button>

            <Button class="mt-10 mb-10 bg-green text-2xl pl-12 pr-12 pt-5 pb-4"
                @click.prevent="handle_click_finish">
                {{ __('Finish') }}
            </Button>

        </div>


    </GuideLayout>


</template>

<script>
import {defineComponent} from "vue";
import GuideLayout from "@/Layouts/GuideLayout";
import Link from "../../Components/Link";
import Button from "../../Components/Button";

export default defineComponent({

    name: "StartupGuideUpdateUserInformation",


    components: {
        Button,
        Link,
        GuideLayout,
    },


    props: {
        email: {
            type: String
        },
        name: {
            type: String,
        },
        errors: {
            type: Object
        }
    },


    created() {

        this.form_email = this.email;

        this.form_name = this.name;

    },


    data() {
        return {
            password: '',
            password_confirmation: '',
            terms: false,
            pros: [
                'More energy both physically and mentally',
                'Present better in workday',
                'Less pains or removes completely',
                'Better concentration',
                'Prevents wear and damage',
                'Greater well-being all day long',
                'Energy when you are free from work'
            ]
        }
    },


    computed: {

        title() {

            return this.__('Startup Guide, Update User Information');

        }

    },


    methods: {


        handle_click_previous() {

            this.$inertia.visit(
                this.route('startup_guide_notifications'),
            );

        },


        handle_email_input() {

            this.email_changed = true;

        },


        handle_click_finish() {

            let
                data = {
                    name: this.form_name,
                    terms: this.terms
                }
            ;

            if ( this.email_changed ) {

                data.email = this.form_email;

            }

            if ( this.password ) {

                data.password = this.password;

                data.password_confirmation = this.password_confirmation

            }

            this.$inertia.patch(
                this.route('user_set_startup_guide_completed'),
                data,
                {
                    preserveScroll: false,
                    onSuccess: () => {

                        this.$inertia.visit(
                            this.route('your_exercises')
                        );

                    }
                }
            );

        }

    }

});
</script>

<style scoped>

</style>
